const TableHeader = ({ active, onClick, value }) => {
  return (
    <>
      <div className={active ? "tabs-active" : "tabs"} onClick={onClick}>
        {value}
      </div>
    </>
  );
};

export default TableHeader;
